// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1667358189204
      var cssReload = require("D:/Mega/MRC/mrc-ess-fronted/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  